import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames/bind';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import * as styles from './DHTML.css';

const cx = classNames.bind(styles);

export class DHTML extends Component {
    static defaultProps = {
        html: {},
        automationId: '',
        requestUrl: '',
        componentType: '',
        plccApplyClass: '',
        isplccBenefitPage: '',
        plccAnylyticstrigger: null,
        deviceType: {},
        mktpath: [],
        location: {},
    };

    static propTypes = {
        html: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
        /**
         * Unique name for referencing dom element in automation testing
         * @type {String}
         */
        automationId: PropTypes.string,
        requestUrl: PropTypes.string,
        componentType: PropTypes.string,
        plccApplyClass: PropTypes.string,
        isplccBenefitPage: PropTypes.string,
        deviceType: PropTypes.object,
        plccAnylyticstrigger: PropTypes.func,
        mktpath: PropTypes.array,
        location: PropTypes.object,
    };

    constructor() {
        super();
        this.dhtmlWrapper = React.createRef();
        this.insertScript = [];
    }

    componentDidMount() {
        const {
            plccApplyClass,
            isplccBenefitPage,
            plccAnylyticstrigger,
            deviceType,
            mktpath,
            location,
        } = this.props;
        const path = window.location.pathname;
        const plccApplyButton =
            isplccBenefitPage &&
            this.dhtmlWrapper.current &&
            this.dhtmlWrapper.current.querySelector(plccApplyClass);
        if (plccApplyButton) {
            this.dhtmlWrapper.current
                .querySelector(plccApplyClass)
                .addEventListener('click', () => {
                    plccAnylyticstrigger();
                });
        }
        if (this.insertScript && this.insertScript.length) {
            this.insertScript.forEach((currentScript) => {
                const s = document.createElement('script');
                s.type = 'text/javascript';
                s.async = true;
                s.innerHTML = currentScript;
                this.dhtmlWrapper.current.appendChild(s);
            });
        }

        this.handleHashScroll();
        /* istanbul ignore next */
        if (mktpath.includes(path)) {
            this.handleHashScroll();
            if (!__SERVER__) {
                window.addEventListener('hashchange', this.handleHashScroll);
                window.addEventListener('popstate', this.handleHashScroll);

                setTimeout(() => {
                    this.handleHashScroll();
                }, 100);
            }
        }
    }

    /* istanbul ignore next */
    componentWillUnmount() {
        if (!__SERVER__) {
            window.removeEventListener('hashchange', this.handleHashScroll);
            window.removeEventListener('popstate', this.handleHashScroll);
        }
    }

    /* istanbul ignore next */
    componentDidUpdate(prevProps) {
        const { mktpath } = this.props;
        const path = window.location.pathname;

        if (mktpath.includes(path)) {
            const prevFullPath = prevProps.location.pathname + prevProps.location.hash;
            const currentFullPath = this.props.location.pathname + this.props.location.hash;

            if (prevFullPath !== currentFullPath) {
                this.handleHashScroll();
            }
        }
    }

    /* istanbul ignore next */
    handleHashScroll = () => {
        const { deviceType, mktpath } = this.props;

        if (__SERVER__ || deviceType.isDesktop) return;

        const path = window.location.pathname;
        const { hash } = window.location;

        if (mktpath.includes(path) && hash) {
            requestAnimationFrame(() => {
                let targetElement = null;

                try {
                    targetElement = document.querySelector(hash);
                } catch (err) {
                    return;
                }

                if (targetElement) {
                    const header = document.querySelector('header');
                    const headerHeight = header ? header.offsetHeight : 0;
                    const offset = headerHeight - 25;
                    const elementPosition =
                        targetElement.getBoundingClientRect().top + window.scrollY;

                    window.scrollTo({
                        top: elementPosition - offset,
                        behavior: 'smooth',
                    });
                }
            });
        }
    };

    setCopyText = () => {
        const { automationId, requestUrl, componentType } = this.props;
        let { html } = this.props;

        // Pattern to extract all script tags except script tag with src attribute
        const scriptPattern = /(<script(((?!src).)*?>))[^<]*<\/script>/g;

        const isDataPersonalization = () => {
            return html && html.includes('data-personalization');
        };

        if (html && html.length > 0) {
            const containsScript = html.match(scriptPattern);
            if (containsScript && containsScript.length) {
                this.insertScript = containsScript.map(
                    (currentScript) => currentScript.replace(/(<|<\/)script[^>]*>/g, ''),
                    ''
                );
                html = html.replace(scriptPattern, '');
            }
            return (
                <section
                    className={`${dt([
                        'm-0',
                        'bg-white',
                        !requestUrl.includes('/m') && 'overflow-hidden',
                    ])} ${cx('rowBlock')}`}
                >
                    <div
                        className={`${dt([
                            'text-black',
                            'text-sm',
                            'leading-6',
                            'clear-both',
                            '!w-full',
                        ])} ${cx('seoContent')}`}
                        data-automation-id={automationId}
                    >
                        <div ref={this.dhtmlWrapper}>
                            {/* eslint-disable react/no-danger */}
                            <div
                                className={`${
                                    automationId === 'dhtml-content' &&
                                    requestUrl === '/' &&
                                    componentType === 'dhtml'
                                        ? cx('dhtmlInnerContent')
                                        : ''
                                } ${dt([
                                    isDataPersonalization() || automationId === 'seo-block'
                                        ? 'mb-0'
                                        : 'mb-8',
                                ])}`}
                                dangerouslySetInnerHTML={{ __html: html }}
                            />
                        </div>
                    </div>
                </section>
            );
        }

        return null;
    };

    render() {
        return <>{this.setCopyText()}</>;
    }
}

export default DHTML;
